import React from 'react';
import FocusAreaTile from './FocusAreaTile';

export default function BrakingCoachCard({ card, variant = 'hero' }) {
  if (!card) return null;

  const eyebrow = card.type === 'warning'
    ? 'Focus Area'
    : card.type === 'positive'
    ? 'Benchmark'
    : 'Data Source';

  const pills = [
    ...(card.cornerId ? [{ label: card.cornerId, accent: true }] : []),
    ...(card.referenceLabel ? [{ label: card.referenceLabel }] : []),
  ];

  const sections = [
    { label: 'What We Know', body: card.observation },
    { label: 'What It Likely Means', body: card.inference },
    { label: 'What You Should Try', body: card.recommendation },
  ];

  return (
    <FocusAreaTile
      tone={card.type}
      eyebrow={eyebrow}
      title={card.title}
      pills={pills}
      sections={sections}
      variant={variant}
    />
  );
}
